// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../css-loader@6.8.1_webpack@5.88.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nkl-select {
  width: 75%;
}
.label {
  display: flex;
  justify-content: space-between;
}
.label svg {
  margin-top: 0.2rem;
  margin-right: 0.5rem;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
